import React, { useContext } from 'react'
import EventsGrid from './events-grid'
import styled from 'styled-components'
import Container from '../system/container/container'
import { listBreakpoint } from '../event-card/event-card'
import LoadingSpinner from '../system/loading/loading-spinner'
import ToggleableFilters from './toggleable-filters'
import PACEvent from '../../models/event/pac-event'
import ClearFiltersButton from './clear-filters-button'
import breakpoints from '../../styles/breakpoints'
import { FiltersContext } from './filters'

const StyledEvents = styled.div`
  @media (max-width: ${listBreakpoint}) {
    background: url('/images/textures/gray-poly.jpg');
  }

  @media (min-width: ${listBreakpoint}) {
    background-color: ${props => props.theme.colors.white};
  }
`

const StyledContainer = styled(Container)`
  padding-top: ${props => props.theme.spacing.base500};
  padding-bottom: ${props => props.theme.spacing.base500};
`

const NoResults = styled.p`
  font-style: italic;
`

const DesktopClearFilters = styled.div`
  display: none;

  @media (min-width: ${breakpoints.lg}) {
    display: grid;
    justify-content: end;
  }
`

const EventListing = ({
  data,
  loading
}: {
  data: { allEvents: PACEvent[] }
  loading: boolean
}): JSX.Element => {
  const events = (data && data.allEvents) || []
  const { hasFilters } = useContext(FiltersContext)

  return (
    <StyledEvents>
      <StyledContainer>
        <ToggleableFilters />
        <DesktopClearFilters>
          <ClearFiltersButton />
        </DesktopClearFilters>

        <LoadingSpinner loading={loading} />

        {!loading && (
          <>
            {events.length === 0 && (
              <NoResults>
                {hasFilters
                  ? 'No events were found matching those filters.'
                  : 'There are no upcoming events. Check back soon!'}
              </NoResults>
            )}
            <EventsGrid variant="responsive" events={events} />
          </>
        )}
      </StyledContainer>
    </StyledEvents>
  )
}

export default EventListing
